import Emitter from "./Emitter";

export default class BetAmountChange extends Emitter {
    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler(data) {
        if (data.payload && data.payload.betAmount) {
            const dataForXc = {
                "msgId": "rg2xcGameWagerUpdated",
                "value": data.payload.betAmount,
            }

            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify(dataForXc), "*");
            }
        }
    }

    PLAYTECH_handler(data) {
        if (data.payload && data.payload.betAmount && this.gb.ptResFeat && this.gb.ptResFeat.includes('betupdate')) {
            const payload = {
                _type: "ucip.betupdate.g2wBetUpdateNotification",
                totalBet: typeof data.payload.betAmount === "number" ? data.payload.betAmount/100 : data.payload.betAmount,
            }

            if (this.gb.settings.nativeMobileApp) {
                payload.handled = true;
                window.parent.postMessage(JSON.stringify(payload));
                
            } else {
                this.emitParent(JSON.stringify(payload));
            }
        }
    }

    LNWOGS_handler(data) {
        this.gb.wallet.betAmountChange(data.payload.betAmount / 100);
    }

    SOFTSWISS_handler(data) {
        let betAmountInMajorUnit = data.payload.betAmount / 100;
        let currency = this.gb.settings.currencyCode;
        this.emitParent({type: "a8r:v1:gtp:bet_update", payload: { bet_amount: betAmountInMajorUnit, currency: currency}});
    }

    _default(msg) {
        const data = msg ? { wpgaction: "betAmountChange", msg } : { wpgaction: "betAmountChange" };
        const dataParent = msg ? { wpgaction: "betAmountChange.parent", msg } : { wpgaction: "betAmountChange.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
        this.emitiOS(data);
    }
}
